module.exports = __webpack_public_path__ + "img/modern.cb09b5bd.jpg";